// extracted by mini-css-extract-plugin
module.exports = {"root":"wq28KM","error":"JJOQ9H"};